//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class ClientBase {
    constructor(..._args: any[]) {
    }

    protected transformResult(url: string, response: any, processPromise: (response: any) => Promise<any>): Promise<any> {
        return processPromise(response);
    }
}

export class Client extends ClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    get( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class CenterClient extends ClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getClientsTree( cancelToken?: CancelToken): Promise<SuccessModelOfListOfTreeNode> {
        let url_ = this.baseUrl + "/api/Center/GetClientsTree";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetClientsTree(_response));
        });
    }

    protected processGetClientsTree(response: AxiosResponse): Promise<SuccessModelOfListOfTreeNode> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SuccessModelOfListOfTreeNode>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessModelOfListOfTreeNode>(null as any);
    }

    getClientsTable( cancelToken?: CancelToken): Promise<SuccessModelOfListOfClientsTableItem> {
        let url_ = this.baseUrl + "/api/Center/GetClientsTable";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetClientsTable(_response));
        });
    }

    protected processGetClientsTable(response: AxiosResponse): Promise<SuccessModelOfListOfClientsTableItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SuccessModelOfListOfClientsTableItem>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessModelOfListOfClientsTableItem>(null as any);
    }

    getClient(id: string, cancelToken?: CancelToken): Promise<SuccessModelOfClient> {
        let url_ = this.baseUrl + "/api/Center/GetClient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(id);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetClient(_response));
        });
    }

    protected processGetClient(response: AxiosResponse): Promise<SuccessModelOfClient> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SuccessModelOfClient>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessModelOfClient>(null as any);
    }

    addClient(client: Client, cancelToken?: CancelToken): Promise<SuccessModelOfClient> {
        let url_ = this.baseUrl + "/api/Center/AddClient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(client);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processAddClient(_response));
        });
    }

    protected processAddClient(response: AxiosResponse): Promise<SuccessModelOfClient> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SuccessModelOfClient>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessModelOfClient>(null as any);
    }

    updateClient(client: Client, cancelToken?: CancelToken): Promise<SuccessModelOfClient> {
        let url_ = this.baseUrl + "/api/Center/UpdateClient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(client);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateClient(_response));
        });
    }

    protected processUpdateClient(response: AxiosResponse): Promise<SuccessModelOfClient> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SuccessModelOfClient>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessModelOfClient>(null as any);
    }

    removeClient(client: Client, cancelToken?: CancelToken): Promise<SuccessModelOfClient> {
        let url_ = this.baseUrl + "/api/Center/RemoveClient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(client);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRemoveClient(_response));
        });
    }

    protected processRemoveClient(response: AxiosResponse): Promise<SuccessModelOfClient> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SuccessModelOfClient>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessModelOfClient>(null as any);
    }

    getAccount(model: Account, cancelToken?: CancelToken): Promise<SuccessModelOfAccount> {
        let url_ = this.baseUrl + "/api/Center/GetAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAccount(_response));
        });
    }

    protected processGetAccount(response: AxiosResponse): Promise<SuccessModelOfAccount> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SuccessModelOfAccount>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessModelOfAccount>(null as any);
    }

    addAccount(account: Account, cancelToken?: CancelToken): Promise<SuccessModelOfAccount> {
        let url_ = this.baseUrl + "/api/Center/AddAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(account);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processAddAccount(_response));
        });
    }

    protected processAddAccount(response: AxiosResponse): Promise<SuccessModelOfAccount> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SuccessModelOfAccount>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessModelOfAccount>(null as any);
    }

    updateAccount(account: Account, cancelToken?: CancelToken): Promise<SuccessModelOfAccount> {
        let url_ = this.baseUrl + "/api/Center/UpdateAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(account);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateAccount(_response));
        });
    }

    protected processUpdateAccount(response: AxiosResponse): Promise<SuccessModelOfAccount> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SuccessModelOfAccount>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessModelOfAccount>(null as any);
    }

    removeAccount(account: Account, cancelToken?: CancelToken): Promise<SuccessModelOfAccount> {
        let url_ = this.baseUrl + "/api/Center/RemoveAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(account);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRemoveAccount(_response));
        });
    }

    protected processRemoveAccount(response: AxiosResponse): Promise<SuccessModelOfAccount> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SuccessModelOfAccount>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessModelOfAccount>(null as any);
    }

    getMessages( cancelToken?: CancelToken): Promise<SuccessModelOfLogs> {
        let url_ = this.baseUrl + "/api/Center/GetMessages";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetMessages(_response));
        });
    }

    protected processGetMessages(response: AxiosResponse): Promise<SuccessModelOfLogs> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SuccessModelOfLogs>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessModelOfLogs>(null as any);
    }

    getDeviceModels( cancelToken?: CancelToken): Promise<SuccessModelOfModelsInfo> {
        let url_ = this.baseUrl + "/api/Center/GetDeviceModels";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetDeviceModels(_response));
        });
    }

    protected processGetDeviceModels(response: AxiosResponse): Promise<SuccessModelOfModelsInfo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SuccessModelOfModelsInfo>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessModelOfModelsInfo>(null as any);
    }

    addDevices(deviceModel: AddDeviceModel, cancelToken?: CancelToken): Promise<SuccessModelOfCommandResult> {
        let url_ = this.baseUrl + "/api/Center/AddDevices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deviceModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processAddDevices(_response));
        });
    }

    protected processAddDevices(response: AxiosResponse): Promise<SuccessModelOfCommandResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SuccessModelOfCommandResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessModelOfCommandResult>(null as any);
    }

    removeDevices(model: RemoveDevicesModel, cancelToken?: CancelToken): Promise<SuccessModelOfDevices> {
        let url_ = this.baseUrl + "/api/Center/RemoveDevices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRemoveDevices(_response));
        });
    }

    protected processRemoveDevices(response: AxiosResponse): Promise<SuccessModelOfDevices> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SuccessModelOfDevices>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessModelOfDevices>(null as any);
    }

    setCost(model: SetDealerCostModel, cancelToken?: CancelToken): Promise<SuccessModelOfCommandResult> {
        let url_ = this.baseUrl + "/api/Center/SetCost";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSetCost(_response));
        });
    }

    protected processSetCost(response: AxiosResponse): Promise<SuccessModelOfCommandResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SuccessModelOfCommandResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessModelOfCommandResult>(null as any);
    }

    setBalance(model: SetBalanceModel, cancelToken?: CancelToken): Promise<SuccessModelOfCommandResult> {
        let url_ = this.baseUrl + "/api/Center/SetBalance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSetBalance(_response));
        });
    }

    protected processSetBalance(response: AxiosResponse): Promise<SuccessModelOfCommandResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SuccessModelOfCommandResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessModelOfCommandResult>(null as any);
    }

    setBlocked(model: SetBlockedModel, cancelToken?: CancelToken): Promise<SuccessModelOfCommandResult> {
        let url_ = this.baseUrl + "/api/Center/SetBlocked";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSetBlocked(_response));
        });
    }

    protected processSetBlocked(response: AxiosResponse): Promise<SuccessModelOfCommandResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SuccessModelOfCommandResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessModelOfCommandResult>(null as any);
    }

    setBanned(model: SetBannedModel, cancelToken?: CancelToken): Promise<SuccessModelOfCommandResult> {
        let url_ = this.baseUrl + "/api/Center/SetBanned";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSetBanned(_response));
        });
    }

    protected processSetBanned(response: AxiosResponse): Promise<SuccessModelOfCommandResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SuccessModelOfCommandResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessModelOfCommandResult>(null as any);
    }

    setCharge(model: SetChargeModel, cancelToken?: CancelToken): Promise<SuccessModelOfCommandResult> {
        let url_ = this.baseUrl + "/api/Center/SetCharge";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSetCharge(_response));
        });
    }

    protected processSetCharge(response: AxiosResponse): Promise<SuccessModelOfCommandResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SuccessModelOfCommandResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessModelOfCommandResult>(null as any);
    }

    setTestMode(model: SetTestModeModel, cancelToken?: CancelToken): Promise<SuccessModelOfCommandResult> {
        let url_ = this.baseUrl + "/api/Center/SetTestMode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSetTestMode(_response));
        });
    }

    protected processSetTestMode(response: AxiosResponse): Promise<SuccessModelOfCommandResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SuccessModelOfCommandResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessModelOfCommandResult>(null as any);
    }

    setImei(model: SetImeiModel, cancelToken?: CancelToken): Promise<SuccessModelOfCommandResult> {
        let url_ = this.baseUrl + "/api/Center/SetImei";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSetImei(_response));
        });
    }

    protected processSetImei(response: AxiosResponse): Promise<SuccessModelOfCommandResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SuccessModelOfCommandResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessModelOfCommandResult>(null as any);
    }

    setComment(model: SetCommentModel, cancelToken?: CancelToken): Promise<SuccessModelOfCommandResult> {
        let url_ = this.baseUrl + "/api/Center/SetComment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSetComment(_response));
        });
    }

    protected processSetComment(response: AxiosResponse): Promise<SuccessModelOfCommandResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SuccessModelOfCommandResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessModelOfCommandResult>(null as any);
    }

    setStoragePeriod(model: SetStoragePeriodModel, cancelToken?: CancelToken): Promise<SuccessModelOfCommandResult> {
        let url_ = this.baseUrl + "/api/Center/SetStoragePeriod";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSetStoragePeriod(_response));
        });
    }

    protected processSetStoragePeriod(response: AxiosResponse): Promise<SuccessModelOfCommandResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SuccessModelOfCommandResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessModelOfCommandResult>(null as any);
    }

    getAccountMessage(login: string, cancelToken?: CancelToken): Promise<SuccessModelOfAccountMessage> {
        let url_ = this.baseUrl + "/api/Center/GetAccountMessage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(login);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAccountMessage(_response));
        });
    }

    protected processGetAccountMessage(response: AxiosResponse): Promise<SuccessModelOfAccountMessage> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SuccessModelOfAccountMessage>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessModelOfAccountMessage>(null as any);
    }

    setAccountMessage(message: AccountMessage, cancelToken?: CancelToken): Promise<SuccessModelOfCommandResult> {
        let url_ = this.baseUrl + "/api/Center/SetAccountMessage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(message);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSetAccountMessage(_response));
        });
    }

    protected processSetAccountMessage(response: AxiosResponse): Promise<SuccessModelOfCommandResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SuccessModelOfCommandResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessModelOfCommandResult>(null as any);
    }

    findDevice(deviceId: string, cancelToken?: CancelToken): Promise<SuccessModelOfListOfClientsTreeSearchResult> {
        let url_ = this.baseUrl + "/api/Center/FindDevice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deviceId);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processFindDevice(_response));
        });
    }

    protected processFindDevice(response: AxiosResponse): Promise<SuccessModelOfListOfClientsTreeSearchResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SuccessModelOfListOfClientsTreeSearchResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessModelOfListOfClientsTreeSearchResult>(null as any);
    }

    getSoapUsers( cancelToken?: CancelToken): Promise<SuccessModelOfSoapUsers> {
        let url_ = this.baseUrl + "/api/Center/GetSoapUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSoapUsers(_response));
        });
    }

    protected processGetSoapUsers(response: AxiosResponse): Promise<SuccessModelOfSoapUsers> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SuccessModelOfSoapUsers>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessModelOfSoapUsers>(null as any);
    }

    addSoapUser(soapUser: SoapUser, cancelToken?: CancelToken): Promise<SuccessModelOfCommandResult> {
        let url_ = this.baseUrl + "/api/Center/AddSoapUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(soapUser);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processAddSoapUser(_response));
        });
    }

    protected processAddSoapUser(response: AxiosResponse): Promise<SuccessModelOfCommandResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SuccessModelOfCommandResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessModelOfCommandResult>(null as any);
    }

    deleteSoapUsers(soapUser: SoapUsers, cancelToken?: CancelToken): Promise<SuccessModelOfCommandResult> {
        let url_ = this.baseUrl + "/api/Center/DeleteSoapUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(soapUser);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteSoapUsers(_response));
        });
    }

    protected processDeleteSoapUsers(response: AxiosResponse): Promise<SuccessModelOfCommandResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SuccessModelOfCommandResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessModelOfCommandResult>(null as any);
    }

    getAppVersion( cancelToken?: CancelToken): Promise<SuccessModelOfAppVersion> {
        let url_ = this.baseUrl + "/api/Center/GetAppVersion";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAppVersion(_response));
        });
    }

    protected processGetAppVersion(response: AxiosResponse): Promise<SuccessModelOfAppVersion> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SuccessModelOfAppVersion>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessModelOfAppVersion>(null as any);
    }

    getBackendVersion( cancelToken?: CancelToken): Promise<SuccessModelOfString> {
        let url_ = this.baseUrl + "/api/Center/GetBackendVersion";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetBackendVersion(_response));
        });
    }

    protected processGetBackendVersion(response: AxiosResponse): Promise<SuccessModelOfString> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SuccessModelOfString>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessModelOfString>(null as any);
    }

    getFirmwares( cancelToken?: CancelToken): Promise<SuccessModelOfTotalAvailableFirmwares> {
        let url_ = this.baseUrl + "/api/Center/GetFirmwares";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetFirmwares(_response));
        });
    }

    protected processGetFirmwares(response: AxiosResponse): Promise<SuccessModelOfTotalAvailableFirmwares> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SuccessModelOfTotalAvailableFirmwares>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessModelOfTotalAvailableFirmwares>(null as any);
    }

    uploadFirmware(contentType?: string | null | undefined, contentDisposition?: string | null | undefined, headers?: any[] | null | undefined, length?: number | undefined, name?: string | null | undefined, fileName?: string | null | undefined, deviceType?: number | undefined, cancelToken?: CancelToken): Promise<SuccessModelOfCommandResult> {
        let url_ = this.baseUrl + "/api/Center/UploadFirmware";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (contentType !== null && contentType !== undefined)
            content_.append("ContentType", contentType.toString());
        if (contentDisposition !== null && contentDisposition !== undefined)
            content_.append("ContentDisposition", contentDisposition.toString());
        if (headers !== null && headers !== undefined)
            headers.forEach(item_ => content_.append("Headers", item_.toString()));
        if (length === null || length === undefined)
            throw new globalThis.Error("The parameter 'length' cannot be null.");
        else
            content_.append("Length", length.toString());
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (fileName !== null && fileName !== undefined)
            content_.append("FileName", fileName.toString());
        if (deviceType === null || deviceType === undefined)
            throw new globalThis.Error("The parameter 'deviceType' cannot be null.");
        else
            content_.append("deviceType", deviceType.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUploadFirmware(_response));
        });
    }

    protected processUploadFirmware(response: AxiosResponse): Promise<SuccessModelOfCommandResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SuccessModelOfCommandResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessModelOfCommandResult>(null as any);
    }

    getAllDevices( cancelToken?: CancelToken): Promise<SuccessModelOfDictionaryOfStringAndDictionaryOfStringAndListOfDevice> {
        let url_ = this.baseUrl + "/api/Center/GetAllDevices";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAllDevices(_response));
        });
    }

    protected processGetAllDevices(response: AxiosResponse): Promise<SuccessModelOfDictionaryOfStringAndDictionaryOfStringAndListOfDevice> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SuccessModelOfDictionaryOfStringAndDictionaryOfStringAndListOfDevice>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessModelOfDictionaryOfStringAndDictionaryOfStringAndListOfDevice>(null as any);
    }

    getUserCommandsStatus( cancelToken?: CancelToken): Promise<SuccessModelOfUserCommandStatusByDevice> {
        let url_ = this.baseUrl + "/api/Center/GetUserCommandsStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetUserCommandsStatus(_response));
        });
    }

    protected processGetUserCommandsStatus(response: AxiosResponse): Promise<SuccessModelOfUserCommandStatusByDevice> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SuccessModelOfUserCommandStatusByDevice>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessModelOfUserCommandStatusByDevice>(null as any);
    }

    putUserCommand(userCommand: UserCommandBaseRequest, cancelToken?: CancelToken): Promise<SuccessModelOfEmpty> {
        let url_ = this.baseUrl + "/api/Center/PutUserCommand";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userCommand);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPutUserCommand(_response));
        });
    }

    protected processPutUserCommand(response: AxiosResponse): Promise<SuccessModelOfEmpty> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SuccessModelOfEmpty>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessModelOfEmpty>(null as any);
    }

    deleteDataInFuture(deviceIds: string[], cancelToken?: CancelToken): Promise<SuccessModelOfBoolean> {
        let url_ = this.baseUrl + "/api/Center/DeleteDataInFuture";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deviceIds);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteDataInFuture(_response));
        });
    }

    protected processDeleteDataInFuture(response: AxiosResponse): Promise<SuccessModelOfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SuccessModelOfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessModelOfBoolean>(null as any);
    }
}

export class CenterSettingsClient extends ClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getCenterSettings( cancelToken?: CancelToken): Promise<SuccessModelOfCenterSettingsModel> {
        let url_ = this.baseUrl + "/api/Center/GetCenterSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetCenterSettings(_response));
        });
    }

    protected processGetCenterSettings(response: AxiosResponse): Promise<SuccessModelOfCenterSettingsModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SuccessModelOfCenterSettingsModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessModelOfCenterSettingsModel>(null as any);
    }

    updateCenterSettings(model: CenterSettingsModel, cancelToken?: CancelToken): Promise<SuccessModelOfCenterSettingsUpdateResult> {
        let url_ = this.baseUrl + "/api/Center/UpdateCenterSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateCenterSettings(_response));
        });
    }

    protected processUpdateCenterSettings(response: AxiosResponse): Promise<SuccessModelOfCenterSettingsUpdateResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SuccessModelOfCenterSettingsUpdateResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessModelOfCenterSettingsUpdateResult>(null as any);
    }

    restartCenterService( cancelToken?: CancelToken): Promise<SuccessModelOfCenterRestartResult> {
        let url_ = this.baseUrl + "/api/Center/RestartCenterService";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRestartCenterService(_response));
        });
    }

    protected processRestartCenterService(response: AxiosResponse): Promise<SuccessModelOfCenterRestartResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SuccessModelOfCenterRestartResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessModelOfCenterRestartResult>(null as any);
    }
}

export class ModelDeviceServiceClient extends ClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getModelDeviceServices( cancelToken?: CancelToken): Promise<SuccessModelOfModelDeviceServicesInfo> {
        let url_ = this.baseUrl + "/api/Center/GetModelDeviceServices";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetModelDeviceServices(_response));
        });
    }

    protected processGetModelDeviceServices(response: AxiosResponse): Promise<SuccessModelOfModelDeviceServicesInfo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SuccessModelOfModelDeviceServicesInfo>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessModelOfModelDeviceServicesInfo>(null as any);
    }

    startModelDeviceService(request: ModelDeviceServiceRequest, cancelToken?: CancelToken): Promise<SuccessModelOfModelDeviceServiceOperationResult> {
        let url_ = this.baseUrl + "/api/Center/StartModelDeviceService";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processStartModelDeviceService(_response));
        });
    }

    protected processStartModelDeviceService(response: AxiosResponse): Promise<SuccessModelOfModelDeviceServiceOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SuccessModelOfModelDeviceServiceOperationResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessModelOfModelDeviceServiceOperationResult>(null as any);
    }

    stopModelDeviceService(request: ModelDeviceServiceRequest, cancelToken?: CancelToken): Promise<SuccessModelOfModelDeviceServiceOperationResult> {
        let url_ = this.baseUrl + "/api/Center/StopModelDeviceService";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processStopModelDeviceService(_response));
        });
    }

    protected processStopModelDeviceService(response: AxiosResponse): Promise<SuccessModelOfModelDeviceServiceOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SuccessModelOfModelDeviceServiceOperationResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessModelOfModelDeviceServiceOperationResult>(null as any);
    }

    restartModelDeviceService(request: ModelDeviceServiceRequest, cancelToken?: CancelToken): Promise<SuccessModelOfModelDeviceServiceOperationResult> {
        let url_ = this.baseUrl + "/api/Center/RestartModelDeviceService";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRestartModelDeviceService(_response));
        });
    }

    protected processRestartModelDeviceService(response: AxiosResponse): Promise<SuccessModelOfModelDeviceServiceOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SuccessModelOfModelDeviceServiceOperationResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessModelOfModelDeviceServiceOperationResult>(null as any);
    }

    installModelDeviceService(request: InstallModelDeviceServiceRequest, cancelToken?: CancelToken): Promise<SuccessModelOfModelDeviceServiceOperationResult> {
        let url_ = this.baseUrl + "/api/Center/InstallModelDeviceService";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processInstallModelDeviceService(_response));
        });
    }

    protected processInstallModelDeviceService(response: AxiosResponse): Promise<SuccessModelOfModelDeviceServiceOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SuccessModelOfModelDeviceServiceOperationResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessModelOfModelDeviceServiceOperationResult>(null as any);
    }

    removeModelDeviceService(request: RemoveModelDeviceServiceRequest, cancelToken?: CancelToken): Promise<SuccessModelOfModelDeviceServiceOperationResult> {
        let url_ = this.baseUrl + "/api/Center/RemoveModelDeviceService";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRemoveModelDeviceService(_response));
        });
    }

    protected processRemoveModelDeviceService(response: AxiosResponse): Promise<SuccessModelOfModelDeviceServiceOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SuccessModelOfModelDeviceServiceOperationResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessModelOfModelDeviceServiceOperationResult>(null as any);
    }

    updateModelDeviceServiceSettings(request: UpdateModelDeviceServiceSettingsRequest, cancelToken?: CancelToken): Promise<SuccessModelOfModelDeviceServiceOperationResult> {
        let url_ = this.baseUrl + "/api/Center/UpdateModelDeviceServiceSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateModelDeviceServiceSettings(_response));
        });
    }

    protected processUpdateModelDeviceServiceSettings(response: AxiosResponse): Promise<SuccessModelOfModelDeviceServiceOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SuccessModelOfModelDeviceServiceOperationResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessModelOfModelDeviceServiceOperationResult>(null as any);
    }
}

export class AccountClient extends ClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    signIn(model: LoginModel, cancelToken?: CancelToken): Promise<LoginResponse> {
        let url_ = this.baseUrl + "/api/Account/sign-in";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSignIn(_response));
        });
    }

    protected processSignIn(response: AxiosResponse): Promise<LoginResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<LoginResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LoginResponse>(null as any);
    }

    auth( cancelToken?: CancelToken): Promise<AuthResponse> {
        let url_ = this.baseUrl + "/api/Account/auth";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processAuth(_response));
        });
    }

    protected processAuth(response: AxiosResponse): Promise<AuthResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<AuthResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthResponse>(null as any);
    }

    signOut( cancelToken?: CancelToken): Promise<SignOutResponse> {
        let url_ = this.baseUrl + "/api/Account/sign-out";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSignOut(_response));
        });
    }

    protected processSignOut(response: AxiosResponse): Promise<SignOutResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<SignOutResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SignOutResponse>(null as any);
    }

    refresh(refreshToken?: string | null | undefined, cancelToken?: CancelToken): Promise<RefreshResponse> {
        let url_ = this.baseUrl + "/api/Account/refresh?";
        if (refreshToken !== undefined && refreshToken !== null)
            url_ += "refreshToken=" + encodeURIComponent("" + refreshToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRefresh(_response));
        });
    }

    protected processRefresh(response: AxiosResponse): Promise<RefreshResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<RefreshResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RefreshResponse>(null as any);
    }
}

export class ErrorClient extends ClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    writeClientError(errorData?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Error/WriteClientError";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(errorData);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processWriteClientError(_response));
        });
    }

    protected processWriteClientError(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class LogsClient extends ClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    post(logMessage: LogRequest, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Logs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(logMessage);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPost(_response));
        });
    }

    protected processPost(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface SuccessModelOfListOfTreeNode {
    success: boolean;
    responseText: string;
    data: TreeNode[] | undefined;
}

export interface TreeNode {
    key: string;
    index: number;
    id: string;
    name: string;
    parentNodeId: string;
    parentId: string;
    label: string;
    type: string;
    children: TreeNode[];
}

export interface SuccessModelOfListOfClientsTableItem {
    success: boolean;
    responseText: string;
    data: ClientsTableItem[] | undefined;
}

export interface ClientsTableItem {
    number: string;
    name: string;
    loginsCount: number;
    devicesCount: number;
}

export interface SuccessModelOfClient {
    success: boolean;
    responseText: string;
    data: Client | undefined;
}

export interface Client {
    Id: string | undefined;
    Name: string | undefined;
    IsClientBlocked: boolean;
    IsDealerBlocked: boolean;
    IsBillingDisabled: boolean;
    Comment: string | undefined;
    Accounts: Account[] | undefined;
    Login: string | undefined;
    Password: string | undefined;
    DefaultDealerCost: number;
}

export interface Account {
    Login: string | undefined;
    Password: string | undefined;
    Devices: Devices | undefined;
    ClientId: string | undefined;
    OriginalLogin: string | undefined;
}

export interface Devices {
    Devices_: Device[] | undefined;
}

export interface Device {
    Id: string | undefined;
    Model: number;
    Serial: string | undefined;
    DeviceModelName: string | undefined;
    Blocked: boolean;
    Banned: boolean;
    Charge: number;
    Comment: string | undefined;
    TodayCount: number;
    Balance: number;
    JsonProps: string | undefined;
    SaveTime: number;
    Imei: string | undefined;
    Cost: number;
    LastDataTime: Timestamp | undefined;
    TestMode: string | undefined;
    StoragePeriod: number;
    Company: string | undefined;
    Logins: string[] | undefined;
}

/** A Timestamp represents a point in time independent of any time zone or local calendar, encoded as a count of seconds and fractions of seconds at nanosecond resolution. The count is relative to an epoch at UTC midnight on January 1, 1970, in the proleptic Gregorian calendar which extends the Gregorian calendar backwards to year one.            All minutes are 60 seconds long. Leap seconds are "smeared" so that no leap second table is needed for interpretation, using a [24-hour linear smear](https://developers.google.com/time/smear).            The range is from 0001-01-01T00:00:00Z to 9999-12-31T23:59:59.999999999Z. By restricting to that range, we ensure that we can convert to and from [RFC 3339](https://www.ietf.org/rfc/rfc3339.txt) date strings.            # Examples            Example 1: Compute Timestamp from POSIX `time()`.               Timestamp timestamp;    timestamp.set_seconds(time(NULL));    timestamp.set_nanos(0);            Example 2: Compute Timestamp from POSIX `gettimeofday()`.               struct timeval tv;    gettimeofday(&tv, NULL);               Timestamp timestamp;    timestamp.set_seconds(tv.tv_sec);    timestamp.set_nanos(tv.tv_usec * 1000);            Example 3: Compute Timestamp from Win32 `GetSystemTimeAsFileTime()`.               FILETIME ft;    GetSystemTimeAsFileTime(&ft);    UINT64 ticks = (((UINT64)ft.dwHighDateTime) << 32) | ft.dwLowDateTime;               // A Windows tick is 100 nanoseconds. Windows epoch 1601-01-01T00:00:00Z    // is 11644473600 seconds before Unix epoch 1970-01-01T00:00:00Z.    Timestamp timestamp;    timestamp.set_seconds((INT64) ((ticks / 10000000) - 11644473600LL));    timestamp.set_nanos((INT32) ((ticks % 10000000) * 100));            Example 4: Compute Timestamp from Java `System.currentTimeMillis()`.               long millis = System.currentTimeMillis();               Timestamp timestamp = Timestamp.newBuilder().setSeconds(millis / 1000)        .setNanos((int) ((millis % 1000) * 1000000)).build();            Example 5: Compute Timestamp from Java `Instant.now()`.               Instant now = Instant.now();               Timestamp timestamp =        Timestamp.newBuilder().setSeconds(now.getEpochSecond())            .setNanos(now.getNano()).build();            Example 6: Compute Timestamp from current time in Python.               timestamp = Timestamp()    timestamp.GetCurrentTime()            # JSON Mapping            In JSON format, the Timestamp type is encoded as a string in the [RFC 3339](https://www.ietf.org/rfc/rfc3339.txt) format. That is, the format is "{year}-{month}-{day}T{hour}:{min}:{sec}[.{frac_sec}]Z" where {year} is always expressed using four digits while {month}, {day}, {hour}, {min}, and {sec} are zero-padded to two digits each. The fractional seconds, which can go up to 9 digits (i.e. up to 1 nanosecond resolution), are optional. The "Z" suffix indicates the timezone ("UTC"); the timezone is required. A proto3 JSON serializer should always use UTC (as indicated by "Z") when printing the Timestamp type and a proto3 JSON parser should be able to accept both UTC and other timezones (as indicated by an offset).            For example, "2017-01-15T01:30:15.01Z" encodes 15.01 seconds past 01:30 UTC on January 15, 2017.            In JavaScript, one can convert a Date object to this format using the standard [toISOString()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toISOString) method. In Python, a standard `datetime.datetime` object can be converted to this format using [`strftime`](https://docs.python.org/2/library/time.html#time.strftime) with the time format spec '%Y-%m-%dT%H:%M:%S.%fZ'. Likewise, in Java, one can use the Joda Time's [`ISODateTimeFormat.dateTime()`]( http://joda-time.sourceforge.net/apidocs/org/joda/time/format/ISODateTimeFormat.html#dateTime() ) to obtain a formatter capable of generating timestamps in this format. */
export interface Timestamp {
    /** Represents seconds of UTC time since Unix epoch
1970-01-01T00:00:00Z. Must be from 0001-01-01T00:00:00Z to
9999-12-31T23:59:59Z inclusive. */
    Seconds: number;
    /** Non-negative fractions of a second at nanosecond resolution. Negative
second values with fractions must still have non-negative nanos values
that count forward in time. Must be from 0 to 999,999,999
inclusive. */
    Nanos: number;
}

export interface SuccessModelOfAccount {
    success: boolean;
    responseText: string;
    data: Account | undefined;
}

export interface SuccessModelOfLogs {
    success: boolean;
    responseText: string;
    data: Logs | undefined;
}

export interface Logs {
    Items: LogRequest[] | undefined;
    LastLogId: number;
}

export interface LogRequest {
    ServiceName: string | undefined;
    EntryType: number;
    Time: Timestamp | undefined;
    Message: string | undefined;
    Additional: string | undefined;
    Exception: string | undefined;
    IsShow: boolean;
    LogId: number;
}

export interface SuccessModelOfModelsInfo {
    success: boolean;
    responseText: string;
    data: ModelsInfo | undefined;
}

export interface ModelsInfo {
    Items: ModelInfo[] | undefined;
}

export interface ModelInfo {
    ModelId: number;
    ModelName: string | undefined;
    Protocol: number;
}

export interface SuccessModelOfCommandResult {
    success: boolean;
    responseText: string;
    data: CommandResult | undefined;
}

export interface CommandResult {
    Success: boolean;
    Description: string | undefined;
}

export interface AddDeviceModel {
    SerialFrom: number;
    SerialTo: number;
    Device: Device | undefined;
    ClientId: string | undefined;
    TestMode: boolean;
}

export interface SuccessModelOfDevices {
    success: boolean;
    responseText: string;
    data: Devices | undefined;
}

export interface RemoveDevicesModel {
    DeviceIds: string[] | undefined;
    ClientId: string | undefined;
}

export interface SetDealerCostModel {
    DeviceIds: string[] | undefined;
    Cost: number;
}

export interface SetBalanceModel {
    DeviceIds: string[] | undefined;
    Balance: number;
}

export interface SetBlockedModel {
    DeviceIds: string[] | undefined;
    Blocked: boolean;
}

export interface SetBannedModel {
    DeviceIds: string[] | undefined;
    Banned: boolean;
}

export interface SetChargeModel {
    DeviceIds: string[] | undefined;
    Charge: number;
}

export interface SetTestModeModel {
    DeviceIds: string[] | undefined;
}

export interface SetImeiModel {
    DeviceId: string | undefined;
    Imei: string | undefined;
}

export interface SetCommentModel {
    DeviceIds: string[] | undefined;
    Comment: string | undefined;
}

export interface SetStoragePeriodModel {
    DeviceIds: string[] | undefined;
    StoragePeriod: number;
}

export interface SuccessModelOfAccountMessage {
    success: boolean;
    responseText: string;
    data: AccountMessage | undefined;
}

export interface AccountMessage {
    Id: number;
    Login: string | undefined;
    Kind: string | undefined;
    Message: string | undefined;
    Period: Duration | undefined;
    LastSend: Timestamp | undefined;
}

/** A Duration represents a signed, fixed-length span of time represented as a count of seconds and fractions of seconds at nanosecond resolution. It is independent of any calendar and concepts like "day" or "month". It is related to Timestamp in that the difference between two Timestamp values is a Duration and it can be added or subtracted from a Timestamp. Range is approximately +-10,000 years.            # Examples            Example 1: Compute Duration from two Timestamps in pseudo code.               Timestamp start = ...;    Timestamp end = ...;    Duration duration = ...;               duration.seconds = end.seconds - start.seconds;    duration.nanos = end.nanos - start.nanos;               if (duration.seconds < 0 && duration.nanos > 0) {      duration.seconds += 1;      duration.nanos -= 1000000000;    } else if (duration.seconds > 0 && duration.nanos < 0) {      duration.seconds -= 1;      duration.nanos += 1000000000;    }            Example 2: Compute Timestamp from Timestamp + Duration in pseudo code.               Timestamp start = ...;    Duration duration = ...;    Timestamp end = ...;               end.seconds = start.seconds + duration.seconds;    end.nanos = start.nanos + duration.nanos;               if (end.nanos < 0) {      end.seconds -= 1;      end.nanos += 1000000000;    } else if (end.nanos >= 1000000000) {      end.seconds += 1;      end.nanos -= 1000000000;    }            Example 3: Compute Duration from datetime.timedelta in Python.               td = datetime.timedelta(days=3, minutes=10)    duration = Duration()    duration.FromTimedelta(td)            # JSON Mapping            In JSON format, the Duration type is encoded as a string rather than an object, where the string ends in the suffix "s" (indicating seconds) and is preceded by the number of seconds, with nanoseconds expressed as fractional seconds. For example, 3 seconds with 0 nanoseconds should be encoded in JSON format as "3s", while 3 seconds and 1 nanosecond should be expressed in JSON format as "3.000000001s", and 3 seconds and 1 microsecond should be expressed in JSON format as "3.000001s". */
export interface Duration {
    /** Signed seconds of the span of time. Must be from -315,576,000,000
to +315,576,000,000 inclusive. Note: these bounds are computed from:
60 sec/min * 60 min/hr * 24 hr/day * 365.25 days/year * 10000 years */
    Seconds: number;
    /** Signed fractions of a second at nanosecond resolution of the span
of time. Durations less than one second are represented with a 0
`seconds` field and a positive or negative `nanos` field. For durations
of one second or more, a non-zero value for the `nanos` field must be
of the same sign as the `seconds` field. Must be from -999,999,999
to +999,999,999 inclusive. */
    Nanos: number;
}

export interface SuccessModelOfListOfClientsTreeSearchResult {
    success: boolean;
    responseText: string;
    data: ClientsTreeSearchResult[] | undefined;
}

export interface ClientsTreeSearchResult {
    node: TreeNode;
    isDevice: boolean;
    modelName: string;
    model: number;
    serial: string;
    login: string;
    client: string;
}

export interface SuccessModelOfSoapUsers {
    success: boolean;
    responseText: string;
    data: SoapUsers | undefined;
}

export interface SoapUsers {
    Users: SoapUser[] | undefined;
}

export interface SoapUser {
    Login: string | undefined;
    ApiKey: string | undefined;
}

export interface SuccessModelOfAppVersion {
    success: boolean;
    responseText: string;
    data: AppVersion | undefined;
}

export interface AppVersion {
    Version: string | undefined;
}

export interface SuccessModelOfString {
    success: boolean;
    responseText: string;
    data: string | undefined;
}

export interface SuccessModelOfTotalAvailableFirmwares {
    success: boolean;
    responseText: string;
    data: TotalAvailableFirmwares | undefined;
}

export interface TotalAvailableFirmwares {
    Items: ProtocolAvailableFirmwares[] | undefined;
}

export interface ProtocolAvailableFirmwares {
    ProtocolType: number;
    Firmwares: string[] | undefined;
    ModelId: number;
}

export interface SuccessModelOfDictionaryOfStringAndDictionaryOfStringAndListOfDevice {
    success: boolean;
    responseText: string;
    data: { [key: string]: { [key: string]: Device[]; }; } | undefined;
}

export interface SuccessModelOfUserCommandStatusByDevice {
    success: boolean;
    responseText: string;
    data: UserCommandStatusByDevice | undefined;
}

export interface UserCommandStatusByDevice {
    Statuses: { [key: string]: PerformUserCommandResponse; } | undefined;
}

export interface PerformUserCommandResponse {
    CommandGuid: string | undefined;
    Status: UserCommandStatus;
    DisplayDescription: string | undefined;
    ResultDescription: string | undefined;
    Result: string | undefined;
}

export enum UserCommandStatus {
    Undefined = 0,
    InWork = 1,
    Sended = 2,
    Ok = 128,
    Error = 255,
}

export interface SuccessModelOfEmpty {
    success: boolean;
    responseText: string;
    data: Empty | undefined;
}

/** A generic empty message that you can re-use to avoid defining duplicated empty messages in your APIs. A typical example is to use it as the request or the response type of an API method. For instance:               service Foo {      rpc Bar(google.protobuf.Empty) returns (google.protobuf.Empty);    } */
export interface Empty {
}

export interface UserCommandBaseRequest {
    DevicesByLogin: LoginDevices[] | undefined;
    Type: UserCommandType;
    AdditionalArgs: string | undefined;
}

export interface LoginDevices {
    Login: string | undefined;
    Devices: string[] | undefined;
}

export enum UserCommandType {
    SwitchTudevice = 0,
    FirmwareVersion = 1,
    RestartDevice = 2,
    ReprogFirmware = 3,
    ResetFlash = 4,
    A4Dretrans = 5,
    A4Dwrite = 6,
    ReadConfig = 7,
    InfiniteResponses = 8,
    Unkown = 100,
}

export interface SuccessModelOfBoolean {
    success: boolean;
    responseText: string;
    data: boolean;
}

export interface SuccessModelOfCenterSettingsModel {
    success: boolean;
    responseText: string;
    data: CenterSettingsModel | undefined;
}

export interface CenterSettingsModel {
    ServerGrpcPort: number;
    ServerHttpPort: number;
    ClientServicePort: number;
    ArmHttpProtocolEnabled: boolean;
    ArmHttpProtocolUri: string;
    ManageModelDeviceServices: boolean;
    IsShowUserCommands: boolean;
    IsShowRetransmission: boolean;
    RetransmissionEnabled: boolean;
    GCCollectEnabled: boolean;
    RepairDatabaseOnStart: boolean;
    PurgingDatabaseOnStart: boolean;
    DatabasePurgingEnabled: boolean;
    MaxBadDataCount: number;
    SendingDataInFutureDisabled: boolean;
    StateSavePeriodInSeconds: number;
    StateBackupPeriodInSeconds: number;
    StateBackupArchiveEnabled: boolean;
    DeviceQueriesLimitEnabed: boolean;
    DeviceQueriesLimit: number;
    DOSProtectedEnabled: boolean;
    DOSRowsLimit: number;
    DOSCounterLimit: number;
    DOSPeriodIncrementLimit: number;
    DOSPeriodDecrementLimit: number;
    ChargePerMonth: number;
    MinWorkDaysInMonth: number;
    SuccessDataCounterDisabled: boolean;
    ShowDeviceError: boolean;
    ShowNaturalDeviceError: boolean;
    ShowHardwareCommand: boolean;
    LogDeviceError: boolean;
    WriteLastPackageInState: boolean;
    CounterSaveRatioInSeconds: number;
    AutoRepairEnabled: boolean;
    AutoRepairMaxRateInSeconds: number;
    BadData_ConnectionCount: boolean;
    BadData_SuccessCount: boolean;
    BadData_DataInFuture: boolean;
    BadData_SpamerCount: boolean;
    BadData_UnknownError: boolean;
    BadData_ReprogError: boolean;
    BadData_Auxiliary: boolean;
    BadData_PastDueRestPackage: boolean;
    BadData_GarbageBytes: boolean;
    BadData_NotValidPackageLength: boolean;
    BadData_ControlSumPackageFailed: boolean;
    BadData_NotValidSecretCode: boolean;
    BadData_NotValidDate: boolean;
    BadData_UnknownPackageCommandType: boolean;
    BadData_ForeignerModel: boolean;
    BadData_UnknownImei: boolean;
    BadData_UnknownDevice: boolean;
    BadData_ControlSumDatumFailed: boolean;
    BadData_SoftFaultData: boolean;
    BadData_TruncatedDatum: boolean;
    BadData_NotValidData: boolean;
    BadData_NotFoundClient: boolean;
    BadData_DeviceBanned: boolean;
    BadData_UnsupportedDataType: boolean;
    BadData_NotExistLastData: boolean;
    BadData_DataInPastTime: boolean;
    BadData_DataInFutureTime: boolean;
    BadData_DuplicateDataByLastTime: boolean;
    BadData_DuplicateDataInDatabase: boolean;
    BadData_UnknownDatabaseError: boolean;
    WebPort: number;
    EnableMetricServer: boolean;
    MetricsPort: number;
}

export interface SuccessModelOfCenterSettingsUpdateResult {
    success: boolean;
    responseText: string;
    data: CenterSettingsUpdateResult | undefined;
}

export interface CenterSettingsUpdateResult {
    Success: boolean;
    Message: string;
    RestartRequired: boolean;
    FirewallResult: string;
    LinuxFirewallHint: string;
}

export interface SuccessModelOfCenterRestartResult {
    success: boolean;
    responseText: string;
    data: CenterRestartResult | undefined;
}

export interface CenterRestartResult {
    Success: boolean;
    Message: string;
}

export interface SuccessModelOfModelDeviceServicesInfo {
    success: boolean;
    responseText: string;
    data: ModelDeviceServicesInfo | undefined;
}

export interface ModelDeviceServicesInfo {
    ManagementSupported: boolean;
    Items: ModelDeviceServiceInfo[];
}

export interface ModelDeviceServiceInfo {
    ModelId: number;
    ModelName: string;
    ServiceName: string;
    Status: ModelDeviceServiceStatus;
    GrpcPort: number;
    AccessPort: number;
    Protocol: AccessProtocol;
    EnableMetricServer: boolean;
    MetricsPort: number;
    InstallDirectory: string;
    HealthOk: boolean | undefined;
    HealthReason: string;
    LastError: string;
    LastHealthCheckUtc: Date | undefined;
    StatusDescription: string;
}

export enum ModelDeviceServiceStatus {
    Running = 0,
    Stopped = 1,
    StartPending = 2,
    StopPending = 3,
    NotInstalled = 4,
    Unsupported = 5,
}

export enum AccessProtocol {
    None = 0,
    TCP = 1,
    UDP = 2,
    Socket_UDP = 3,
}

export interface SuccessModelOfModelDeviceServiceOperationResult {
    success: boolean;
    responseText: string;
    data: ModelDeviceServiceOperationResult | undefined;
}

export interface ModelDeviceServiceOperationResult {
    Success: boolean;
    Message: string;
    ScriptOutput: string;
    Error: string;
}

export interface ModelDeviceServiceRequest {
    ModelId: number;
    ModelName: string;
}

export interface InstallModelDeviceServiceRequest extends ModelDeviceServiceRequest {
    GrpcPort: number | undefined;
    AccessPort: number | undefined;
    Protocol: AccessProtocol | undefined;
    EnableMetricServer: boolean | undefined;
    MetricsPort: number | undefined;
    Start: boolean;
    ForceReinstall: boolean;
}

export interface RemoveModelDeviceServiceRequest extends ModelDeviceServiceRequest {
    DeleteFiles: boolean;
}

export interface UpdateModelDeviceServiceSettingsRequest extends ModelDeviceServiceRequest {
    GrpcPort: number | undefined;
    AccessPort: number | undefined;
    Protocol: AccessProtocol | undefined;
    EnableMetricServer: boolean | undefined;
    MetricsPort: number | undefined;
}

export interface LoginResponse {
    user: LoginUser;
    accessToken: string;
    refreshToken: string;
}

export interface LoginUser {
    name: string;
}

export interface LoginModel {
    username: string;
    password: string;
    rememberMe: boolean;
}

export interface AuthResponse {
    success: boolean;
    user: AuthUser;
}

export interface AuthUser {
    id: string;
    username: string;
    expiresAt: number;
}

export interface SignOutResponse {
    success: boolean;
    message: string;
}

export interface RefreshResponse {
    success: boolean;
    accessToken: string;
    refreshToken: string;
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new SwaggerException(message, status, response, headers, result);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}